import React, { Component } from "react";
import DeckRowsView from "./DeckRowsView";
import DecklistFooter from "../DeckBuilderComponents/DecklistFooter"


class DeckListView extends Component {
  render() {


    var deckStyle = {
      backgroundColor: "black",
      color: "white"
    }

    return (
          <table id="decklist" style={deckStyle} className="table table-sm">
              <thead>
                  <tr>
                  <th></th>
                  <th>Card</th>
                  <th></th>
                  <th>Cost</th>
                  <th>Qty</th>
                  <th>Rarity</th>
                  </tr>
              </thead>
              <tbody>
                <DeckRowsView decklist={this.props.decklist} cardPreview={this.props.cardPreview}
                preview={this.props.preview} previewCard={this.props.previewCard} />
              </tbody>
              <tfoot>
                <DecklistFooter deckcount={this.props.deckcount} nanoCost={this.props.nanoCost} />
              </tfoot>
          </table>
    );
  }
}

export default DeckListView;



// WEBPACK FOOTER //
// ./src/DBV2/DeckListView.js